import type { ReactNode } from "react";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";
import { useScope } from "@state/scopeContext.lib";
import type { TasksLanding } from "./tasksLanding";
import { useWorkspaceTasksLanding } from "./useWorkspaceTasksLanding";

interface WorkspaceTasksLandingGateProps {
    children: (landing: TasksLanding) => ReactNode;
}

const LandingGate = ({ children }: WorkspaceTasksLandingGateProps) => {
    const landing = useWorkspaceTasksLanding();

    if (!landing) {
        return <PageCoverLoader />;
    }

    return children(landing);
};

/**
 * Shows the loader until the workspace Tasks page's landing resolves, then
 * renders the page with it. Remounts per workspace, so switching workspaces
 * resolves a fresh landing and resets everything the page renders.
 */
export const WorkspaceTasksLandingGate = ({
    children,
}: WorkspaceTasksLandingGateProps) => {
    const { workspaceId } = useScope();

    return <LandingGate key={workspaceId}>{children}</LandingGate>;
};
